{
    "logout": "Cerrar sesión",
    "loggingOut": "Cerrando sesión…",
    "loading": "Cargando…",
    "cancel": "Cancelar",
    "save": "Guardar",
    "delete": "Eliminar",
    "edit": "Editar",
    "create": "Crear",
    "back": "Volver",
    "nav": {
        "home": "Inicio",
        "profile": "Mi perfil",
        "security": "Mi seguridad",
        "account": {
            "section": "Perfil"
        },
        "platform": {
            "section": "Plataforma",
            "tenants": "Organizaciones",
            "applications": "Aplicaciones",
            "admins": "Administradores",
            "roles": "Roles",
            "branding": "Marca",
            "security": "Seguridad",
            "audit": "Auditoría",
            "groups": {
                "administracion": "Administración",
                "clientes": "Clientes"
            }
        },
        "tenant": {
            "section": "Organización",
            "users": "Usuarios",
            "retailers": "Retailers",
            "groups": "Grupos",
            "roles": "Roles",
            "branding": "Marca",
            "security": "Seguridad",
            "audit": "Auditoría",
            "groupTitles": {
                "estructura": "Estructura",
                "access": "Acceso & Roles",
                "system": "Sistema"
            }
        },
        "retailer": {
            "section": "Retailer",
            "users": "Usuarios",
            "stores": "Tiendas",
            "audit": "Auditoría",
            "comingSoon": "Próximamente",
            "groupTitles": {
                "estructura": "Estructura",
                "access": "Acceso & Roles",
                "system": "Sistema"
            }
        },
        "group": {
            "section": "Grupo",
            "users": "Usuarios",
            "audit": "Auditoría",
            "noGroup": "Selecciona un grupo en el menú.",
            "groupTitles": {
                "access": "Acceso & Roles",
                "system": "Sistema"
            }
        }
    },
    "security": {
        "title": "Mi seguridad",
        "mfa": {
            "preference": "Método MFA",
            "totpSetup": "Configurar TOTP",
            "emailSetup": "Configurar Email MFA",
            "smsSetup": "Configurar SMS MFA"
        },
        "changePassword": "Cambiar contraseña"
    },
    "session": {
        "label": "Sesión iniciada en",
        "platform": "Plataforma Fiado",
        "tenantId": "ID",
        "viewing": "Viendo:"
    }
}
